import React, { useState } from 'react';
import axios from 'axios'

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  Login: (token) => {},
  Logout: () => {},
});

export const AuthContextProvider = (props) => {
  const initialToken = localStorage.getItem('token');
  const [token, setToken] = useState(initialToken);
  const userIsLoggedIn = !!token;

  if (userIsLoggedIn) {
    axios.defaults.headers.common['Authorization'] = "Token "+initialToken;
  }

  const loginHandler = (token) => {
    setToken(token);
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = "Token "+token;
  };

  const logoutHandler = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return <AuthContext.Provider value={contextValue}>
    {props.children}
  </AuthContext.Provider>;
};

export default AuthContext;
